<div class="container">
    <mat-card class="card2">
     
            <h4 class="card-title">Add Banner</h4>
        
        <form (ngSubmit)="f.form.valid && addBanner()" #f="ngForm">
          <div class="row">
            <div class="col-md-4">
    
                    <mat-form-field class="example-full-width">
            
                <mat-label>Select Product</mat-label>
                <mat-select placeholder="Select Dish" name="dish_id" [(ngModel)]="addForm.dish_id" #dish_id="ngModel" required>
                  <mat-option *ngFor="let dish of dish" [value]="dish.id">{{dish.name}}</mat-option>
              </mat-select>
               
                
              </mat-form-field>
              <div
              [hidden]="dish_id.valid || dish_id.pristine"
              class="erro1"
            >Dish is Required
            </div>
            <mat-slide-toggle
            [(ngModel)]="addForm.status"
            name="status"
            #status="ngModel"
            >status</mat-slide-toggle
          ><br><br>      <button mat-raised-button  [disabled]="f.invalid" class="add" >ADD BANNER</button>
            </div>
              <div class="col-md-4">
    
              <mat-form-field class="example-full-width">
                <mat-label>Banner Name</mat-label>
                <input matInput placeholder="Banner Name" name="bannerName" [(ngModel)]="addForm.bannerName" #bannerName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && bannerName.invalid }" required />
            
                <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                  <div *ngIf="firstName.errors.required">Name is required</div>
              </div>        -->
              </mat-form-field>
             
              <div
              [hidden]="bannerName.valid || bannerName.pristine"
              class="erro1"
            >Banner Name is Required
            </div>
    </div>
          
    <div class="col-md-4">
      <ng-container *ngIf="!addForm.image.url; else image">
        <label  class="custom">Upload Image   
        
      <input type="file"  accept="image/*"  name="image" (change)="showPreview($event)" />
    
     
    </label></ng-container>
    <ng-template #image>
      <img src="{{addForm.image.url}}" class="img">
    </ng-template>
    <div *ngIf="currentUpload && !addForm.image.url">
      Progress: {{ currentUpload?.progress }}%
      Complete
      <div class="progress">
        <div
          class="progress-bar progress-bar-animated"
          [ngStyle]="{ width: currentUpload?.progress + '%' }"
        ></div>
    
       
    </div></div>
 
    <div *ngIf="addForm.image.url">
      <mat-icon  (click)="deletePreviousFile()">delete</mat-icon></div>
     
      
    
        
    </div>
    </div>
   
    
        </form>
        </mat-card></div>